export default __webpack_public_path__ + "static/media/sel_courses.0ffe8104.svg";